// NOTE: React.StrictMode causes double rerender to find side-effects

import React from 'react'
import {
  StyledEngineProvider,
  CssVarsProvider,
  extendTheme,
} from '@mui/joy/styles'
import ScopedCssBaseline from '@mui/joy/ScopedCssBaseline'
import { CollectJSProvider } from '@lydiagoulding/react-nmi-collectjs'

// https://mui.com/joy-ui/customization/default-theme-viewer/
const theme = extendTheme({
  // doesnt work
  // fontSize: {
  //   // xs: "0.75rem"
  //   // sm: "0.875rem"
  //   // md: "1rem"
  //   // lg: "1.125rem"
  //   // xl: "1.25rem"
  //   // xl2: "1.5rem"
  //   // xl3: "1.875rem"
  //   // xl4: "2.25rem"
  //   xs: "1.125rem",
  //   sm: "1.25rem",
  //   md: "1rem",
  //   lg: "1.125rem",
  //   xl: "1.25rem",
  //   // xl2: "1.5rem"
  //   // xl3: "1.875rem"
  //   // xl4: "2.25rem"
  // }
  breakpoints: {
    // keys: ['xs', 'sm', 'md', 'lg', 'xl']
    values: {
      // default
      // xs: 0
      // sm: 600
      // md: 900
      // lg: 1200
      // xl: 1536
      xs: 0,
      sm: 576,
      md: 768,
      lg: 992,
      xl: 1200,
    },
  },
})

// console.log(theme)

export default function CommonProviders({ children, collectJSPromise }) {
  return (
    <React.StrictMode>
      <StyledEngineProvider injectFirst>
        <ScopedCssBaseline>
          <CssVarsProvider theme={theme}>
            <CollectJSProvider collectJSPromise={collectJSPromise}>
              {children}
            </CollectJSProvider>
          </CssVarsProvider>
        </ScopedCssBaseline>
      </StyledEngineProvider>
    </React.StrictMode>
  )
}
